// Who the DoBox detail panel's composer currently addresses — drives both the
// "To:" chip label and whether submitting calls delegateInboxEntryToAgent
// (LOCAL_CLAUDE/AGENT) or the regular submitAgentRequest path (ASSISTANT).
export enum DoBoxDelegateComposerTargetKind {
  ASSISTANT = 'ASSISTANT',
  LOCAL_CLAUDE = 'LOCAL_CLAUDE',
  AGENT = 'AGENT',
}
